<template>
  <div>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="pt-8 pb-24 md:pt-20 md:pb-32">
      <div class="container">
        <div class="mb-24 lg:mb-0 max-w-400">
          <h1 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
            Dati Societari
          </h1>
          <p class="mb-4 font-bold">
            UniCredit RE Services S.p.A. Società con socio unico
          </p>
          <p class="mb-4">
            <strong>Capitale Sociale</strong> € 500.000,00 interamente versato
          </p>
          <p class="mb-4">
            Iscrizione al Registro delle Imprese di Milano, Codice Fiscale e
            P.IVA n° 08583660967
          </p>
          <p class="mb-4">
            Numero REA MI-2035532 – Società soggetta a direzione e coordinamento
            da parte di UniCredit S.p.A.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'

export default {
  components: { BreadcrumbsWithShareAccordion },

  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.name,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title: 'Consulta i Dati Societari di UniCredit RE Services',
          description:
            'Dati sulla società di intermediazione immobiliare UniCredit RE Services',
        }
      })
    return { meta }
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Dati Societari',
        },
      ],
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
